<template>
  <div class="container-fluid">
    <div class="row auth-page">
      <div class="col-md-6 col-lg-7 auth-page__leftside">
        <a-welcome />
      </div>
      <div class="col-md-6 col-lg-5 auth-page__rightside">
        <div class="auth-page__rightside-inner">
          <a-sign-up />
          <a-footer />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import aSignUp from '@/components/auth/SignUpForm.vue'
  import aWelcome from '@/components/auth/SignUpWelcome.vue'
  import aFooter from '@/components/auth/AuthFooter.vue'

  export default {
    components: {
      aSignUp,
      aWelcome,
      aFooter
    }
  }
</script>

<style lang="scss" scoped>
  .auth-page {
    overflow: hidden;
    background: #fff;
  }
  .auth-page__leftside {
    min-height: 100vh;
    background: linear-gradient(0deg, rgba(24, 27, 61, 0.7), rgba(24, 27, 61, 0.7)), url('~@/assets/img/login-thumb.jpg');
    background-size: cover;
    padding: 40px;
    display: none;
    align-items: flex-end;
    @media (min-width: $viewport-md) {
      display: flex;
    }
    @media (min-width: $viewport-lg) {
      padding: 100px;
    }
  }
  .auth-page__rightside {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 40px;
    @media (min-width: $viewport-lg) {
      padding: 100px;
      padding-top: 88px;
    }
  }
  .auth-page__rightside-inner {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media (min-width: $viewport-sm) {
      width: 320px;
    }
    @media (min-width: $viewport-xl) {
      width: 480px;
    }
}
</style>
